import { PageHero } from "../components/common/PageHero";
import { IndustriesGrid } from "../components/sections/IndustriesGrid";
import { BpoSection } from "../components/sections/BpoSection";
import { FinalCTA } from "../components/sections/FinalCTA";
import { images } from "../data/content";

export default function Industries() {
    return (
        <>
            <PageHero
                overline="Industries We Serve"
                breadcrumb="Industries"
                title="Workforce solutions across every sector"
                subtitle="FRONTX deploys the right workforce for more than 20 industries — from agriculture and construction to BPO, IT and AI operations."
                image={images.manufacturing}
            />
            <IndustriesGrid showCta={false} />
            <BpoSection />
            <FinalCTA />
        </>
    );
}
